<template>
  <v-app id="portal">
    <v-content class="px-3">
      <titulo-responsivo :titulo="locale[local].screen.telefonia.string001" />
      <v-divider />
      <v-card
        ><v-data-table
          fixed-header
          disable-pagination
          hide-default-footer
          :items="dados"
          :headers="headers"
          class="table-heigth"
          dense
        >
          <template v-slot:top>
            <v-app-bar flat color="transparent">
              <v-container fluid grid-list-md>
                <v-layout class="mt-6">
                  <v-flex offset-lg4 offset-md3 xs12 sm12 lg2 md3>
                    <cgi-data-picker
                      v-model="dataInicial"
                      :label='locale[local].screen.telefonia.string002'
                    ></cgi-data-picker>
                  </v-flex>
                  <v-flex xs12 sm12 lg2 md3>
                    <cgi-data-picker
                      v-model="dataFinal"
                      :label='locale[local].screen.telefonia.string003'
                    ></cgi-data-picker>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-app-bar>
          </template>

          <template v-slot:[`item.dtMovto`]="{ item }">
            {{ moment(item.dtMovto).format("DD/MM/YYYY") }}
          </template>
        </v-data-table></v-card
      >
    </v-content>
  </v-app>
</template>

<script>
import Service from "@/components/api/Service";
import moment from "moment";
import { locale } from '../locale/locale';
export default {
  data: () => ({
    headers: [
      {
        text: locale[window.local].screen.telefonia.table01.header01,
        align: "left",
        sortable: false,
        value: "dtMovto"
      },
      {
        text: locale[window.local].screen.telefonia.table01.header02,
        align: "left",
        sortable: false,
        value: "observacao"
      }
    ],
    service: new Service(),
    loading: false,
    dados: [],
    dataInicial: moment()
      .startOf("month")
      .format("DD/MM/YYYY"),
    dataFinal: moment()
      .endOf("month")
      .format("DD/MM/YYYY")
  }),
  mounted() {
    this.getObservacao();
  },
  watch: {
    dataInicial() {
      this.getObservacao();
    },
    dataFinal() {
      this.getObservacao();
    }
  },
  methods: {
    async getObservacao() {
      this.loading = true;

      try {
        const [diaini, mesini, anoini] = this.dataInicial.split("/");
        const [diafim, mesfim, anofim] = this.dataFinal.split("/");

        const resposta = await this.service.getObservacao({
          codPessoa: parseInt(localStorage.getItem("codPessoa")),
          codEmpregado: 0,
          codEmp: parseInt(localStorage.getItem("codEmp")),
          dtIniObservacao: `${anoini}-${mesini}-${diaini}`,
          dtFimObservacao: `${anofim}-${mesfim}-${diafim}`,
          codObservacao: 25
        });

        if (resposta.status === 200) {
          if (resposta.data.retorno) {
            if (resposta.data.retorno[0].estatus === "Erro") {
              throw new Error(resposta.data.retorno[0].msgErro);
            }
          }

          this.dados = resposta?.data?.Observacao;
        }
      } catch (e) {
        console.log(e);
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.unread {
  background-color: lightgrey;
}

.unread_text {
  font-weight: bold;
}

.table-heigth {
  height: calc(100vh - 130px);
}
</style>
